import React, { FC, useState } from 'react';
import { Button, Form, Modal, Steps } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, OrderedListOutlined, SelectOutlined } from '@ant-design/icons';
import { AssignTariffCards } from './AssignTariffCards';
import { AssignTariffForm } from './AssignTariffForm';
import { IAssignTariffModal } from './AssignTatiffModal';
import { tB, tI, tPlural, tT } from '../../../../translate';
import TariffsStyles from '../../m_styles.less';

export function AssignTariffModalNew({ isOpen, closeStepper, onSuccess, tariff, tariffPackage }: IAssignTariffModal) {
    const [currentStep, setCurrentStep] = useState(0);
    const [isFormComplete, setIsFormComplete] = useState<boolean>(false);
    const [selectedCompanyId, setSelectedCompanyId] = useState<string | undefined>(undefined);
    const [isSending, setIsSending] = useState<boolean>(false);
    const [selectedCardsId, setSelectedCardsId] = useState<string[] | undefined>(undefined);
    const [selectedCardSetsId, setSelectedCardSetsId] = useState<string[] | undefined>(undefined);
    const [availableCardCount, setAvailableCardCount] = useState<number>(0);
    const [form] = Form.useForm();
    const isTariff = !!tariff;
    const selectedTariff = tariff || tariffPackage;

    // const handleModalCancel = () => {
    //     Modal.confirm({
    //         title: tT('Close Dialog?'),
    //         content: tT('Are you sure you want to close this dialog? Any unsaved changes will be lost.'),
    //         okText: tB('Yes'),
    //         cancelText: tB('No'),
    //         onOk() {
    //             closeStepper();
    //         },
    //         wrapClassName: 'modal',
    //     });
    // };
    const items = [
        {
            title: 'Select Tariff',
            icon: <SelectOutlined />,
        },
        {
            title: 'Show Changes',
            disabled: !isFormComplete,
            icon: <OrderedListOutlined />,
        },
    ];
    const onChangeStep = (value: number) => {
        setCurrentStep(value);
    };
    const closeModal = () => {
        form.resetFields();
        setCurrentStep(0);
        closeStepper();
    };

    const clickBuy = () => {
        form.submit();
    };

    const Footer: FC = () => {
        return (
            <div className={TariffsStyles.toolBar}>
                <Button key="back" onClick={closeModal}>
                    {tB('Cancel')}
                </Button>
                <Button
                    key="select"
                    onClick={() => setCurrentStep(0)}
                    disabled={currentStep !== 1}
                    icon={<ArrowLeftOutlined />}
                >
                    {'Select Tariff'}
                </Button>
                <Button
                    key="show"
                    type="primary"
                    onClick={() => setCurrentStep(1)}
                    disabled={currentStep !== 0 || !isFormComplete || !availableCardCount}
                    icon={<ArrowRightOutlined />}
                >
                    {tPlural('show_change', availableCardCount)}
                </Button>
                <Button
                    key="buy"
                    type="primary"
                    onClick={clickBuy}
                    disabled={(currentStep !== 1 && !!availableCardCount) || !isFormComplete || isSending}
                >
                    {tI(isSending ? `Processing Assignment...` : `Buy ${isTariff ? 'Tariff' : 'Tariff Package'}`)}
                </Button>
            </div>
        );
    };

    return (
        <Modal
            destroyOnClose
            footer={<Footer />}
            maskClosable={false}
            // onCancel={handleModalCancel}
            onCancel={closeModal}
            open={isOpen}
            title={tI(`Buy ${isTariff ? 'Tariff' : 'Tariff Package'}`)}
            wrapClassName={'modal'}
            width={650}
        >
            <p>
                {tT(
                    isTariff
                        ? 'Buy a tariff for a card, card set, or all cards in a company'
                        : 'Buy a tariff package for a card, card set, or all cards in a company',
                )}
            </p>
            <Steps current={currentStep} items={items} onChange={onChangeStep} />

            <AssignTariffForm
                form={form}
                isHide={currentStep !== 0}
                onSuccess={onSuccess}
                setCloseModal={closeModal}
                setIsFormComplete={setIsFormComplete}
                setIsSending={setIsSending}
                setSelectedCardSetsId={setSelectedCardSetsId}
                setSelectedCardsId={setSelectedCardsId}
                setSelectedCompanyId={setSelectedCompanyId}
                tariff={tariff}
                tariffPackage={tariffPackage}
            />
            <AssignTariffCards
                cardSetsId={selectedCardSetsId}
                cardsId={selectedCardsId}
                companyId={selectedCompanyId}
                isHide={currentStep !== 1}
                setCardCount={setAvailableCardCount}
                selectedTariff={{ ...selectedTariff, id: Number(selectedTariff?.id || 0) }}
            />
        </Modal>
    );
}
